export enum OrderType {
  NonPerformingInventory = "Non-Performing Inv",
  SubjectToCount = "Subject To Count",
  dropAndStay = "Drop and Stay",
  SubjectToCnt = "Subject to CNT",
  InternalSupplies = "Internal Supplies",
  CustomerReturn = "Customer Return",
  ReturnToSupplier = "Return to Supplier",
  XpsSampleRouteTwo = "XPS Sample Route 2",
  XpsSampleRouteThree = "XPS Sample Route 3",
  VendorPickup = "Vendor Pickup",
  Custom = "Custom",
  Regular = "Regular Order DOT De",
  Transfer = "Transfers",
  NonChepPallets = "Non-Chep Pallets",
  CustomTanker = "Custom Tanker",
  Pending = "Pending",
  Split = "Split",
  EmptyAtw = "Empty ATW",
  CustomerPickup = "Customer Pickup",
  EmptyDoublesTrailer = "Empty Doubles Traile",
  Distressed = "Distressed",
  Donation = "Donation",
  DamageToStore = "Damage to Store",
  Charity = "Charity",
  CrossDockAtCustomer = "Cross Dock at Custom",
  ShuttleLoad = "Shuttle Load",
}
